module.exports = __webpack_public_path__ + "static/media/Etiquetas4.aa4a9970.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancEtiquetas/Etiquetas4.png
// module id = 2258
// module chunks = 0